window.global ||= window;

import { CaretUpOutlined } from "@ant-design/icons";
import * as Sentry from "@sentry/react";
import { BackTop } from "antd";
import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { Provider } from "./Context";
import LoginPopUp from "./components/login/LoginPopUp";
import MatomoTracker from "./components/matomo-tracker";
import constants from "./constants";
import Routes from "./routes";
import { TimeoutProvider } from "./services/Contexts/TimeoutContext";
import timeoutCheck from "./services/userTimeoutCheck";

import "@ant-design/compatible/assets/index.css";

import "@gooddata/sdk-ui-charts/styles/css/main.css";
import "@gooddata/sdk-ui-dashboard/styles/css/main.css";
import "@gooddata/sdk-ui-ext/styles/css/main.css";
import "@gooddata/sdk-ui-filters/styles/css/main.css";
import "@gooddata/sdk-ui-geo/styles/css/main.css";
import "@gooddata/sdk-ui-pivot/styles/css/main.css";

import "antd/dist/antd.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "rsuite/dist/styles/rsuite-default.css";
import "sweetalert2/src/sweetalert2.scss";

import "./assets/styles/app.css";
import "./assets/styles/new_ui.scss";

import "./assets/styles/custom/AddEvents.scss";
import "./assets/styles/custom/AllContacts.scss";
import "./assets/styles/custom/AppovalSummaryModal.scss";
import "./assets/styles/custom/Audience.scss";
import "./assets/styles/custom/AutosegmentTab.scss";
import "./assets/styles/custom/CampaginDashboard.scss";
import "./assets/styles/custom/Campaign.scss";
import "./assets/styles/custom/Campaign_n.scss";
import "./assets/styles/custom/Compose.scss";
import "./assets/styles/custom/Config.scss";
import "./assets/styles/custom/ContactReport.scss";
import "./assets/styles/custom/Dashboard.scss";
import "./assets/styles/custom/Forms.scss";
import "./assets/styles/custom/InstagramCard.scss";
import "./assets/styles/custom/Integration.scss";
import "./assets/styles/custom/Upload.scss";
import "./assets/styles/custom/ads.scss";
import "./assets/styles/custom/components/AllModal.scss";
import "./assets/styles/custom/factcube.scss";
import "./assets/styles/custom/fb.scss";
import "./assets/styles/custom/fbAd.scss";
import "./assets/styles/custom/journey_builder/tools/LeftPanel.scss";
import "./assets/styles/custom/journey_selection_wizard/journey_selection.scss";
import "./assets/styles/custom/whatsappTemplateStyles.scss";

const hostname = window.location.hostname;

// verify if the user had logged in and localStorage key exists
const now = new Date();
const expireTime = window.localStorage.getItem("expireTime");
if (expireTime) {
	if (now.getTime() > expireTime) {
		timeoutCheck(expireTime);
	}
}

const environment = constants.environments[hostname];
Sentry.init({
	dsn: "https://409abba29d17dbcb1ec01af75ff8294c@o4509174280814592.ingest.us.sentry.io/4509195142692864",

	integrations: [Sentry.browserTracingIntegration()],
	tracesSampleRate: 1.0,
	tracePropagationTargets: [...constants.all_domains, "me.satisfi7.com"],

	enabled: ["production", "staging"].includes(environment),
	environment,
});

ReactDOM.render(
	<Provider>
		<TimeoutProvider>
			<MatomoTracker
				siteId={constants.matomoScripts[hostname]?.siteId}
				matomoUrl={constants.matomoScripts[hostname]?.matomoUrl}
			/>
			<LoginPopUp />
			<Routes />
			<BackTop visibilityHeight={150}>
				<div className="back-to-top-button">
					<CaretUpOutlined />
				</div>
			</BackTop>
			<LoadGoogleAnalytics />
		</TimeoutProvider>
	</Provider>,
	document.getElementById("root"),
);

function setupGoogleAnalytics() {
	console.log("Setting up Google Analytics");

	/* Start - GA script based on Environment*/
	if (
		constants.all_env_hostnames.QA.includes(hostname) ||
		constants.all_env_hostnames.STAGE.includes(hostname)
	) {
		const s1 = document.createElement("script");
		s1.src = "https://www.googletagmanager.com/gtag/js?id=G-MBZ4J3EJJJ";
		s1.async = true;

		const s2 = document.createElement("script");
		s2.innerHTML = `function gtag(){dataLayer.push(arguments)}window.dataLayer=window.dataLayer||[],gtag("js",new Date),gtag("config","G-MBZ4J3EJJJ")`;

		document.head.appendChild(s1);
		document.head.appendChild(s2);
	} else if (constants.all_env_hostnames.PROD.includes(hostname)) {
		const s1 = document.createElement("script");
		s1.src = "https://www.googletagmanager.com/gtag/js?id=G-BLSSYEJP5Y";
		s1.async = true;

		const s2 = document.createElement("script");
		s2.innerHTML = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-BLSSYEJP5Y');`;

		document.head.appendChild(s2);
		document.head.appendChild(s1);
	}
	/* End - GA script based on Environment*/
	window.loadedMaps = true;
}

function setupGoogleMaps() {
	console.log("Setting up Google Maps");
	// Google MAP script tag with API key
	const src = new URL("https://maps.googleapis.com/maps/api/js");
	src.searchParams.append("libraries", "places");
	src.searchParams.append("loading", "async");
	src.searchParams.append("key", "AIzaSyB0RsREImukAouU71_2PkWyvPZt6OC6I44");

	const s3 = document.createElement("script");
	s3.src = src.toString();
	s3.defer = true;
	document.head.appendChild(s3);
	window.loadedMaps = true;
}

function LoadGoogleAnalytics() {
	useEffect(() => {
		if (!window.loadedMaps) {
			if (constants.captcha_whitelist.includes(hostname)) {
				setupGoogleAnalytics();
			}
			setupGoogleMaps();
		}
	}, []);
	return null;
}
